'use client';

import { createContext } from 'react';

import { Profile } from '@/shared/types';

interface ProfileContextType {
  profile: Profile | null;
  isLoading: boolean;
}

const ProfileContext = createContext<ProfileContextType>({
  profile: null,
  isLoading: false,
});

export default ProfileContext;
